/**
 *
 * @param param The query parameter whose value should be read.
 * @returns The value of the specified query parameter, or null.
 */
export function getQueryParams(param) {
    return new URLSearchParams(window.location.search).get(param);
}
//# sourceMappingURL=getQueryParams.js.map